// components/Formations.js
import React, { useState, useEffect, useRef } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { FaSearch, FaBook, FaClock, FaUserGraduate, FaCertificate, FaCalendarAlt, FaEye, FaQuoteLeft, FaArrowLeft, FaArrowRight } from 'react-icons/fa';
import { MdOutlineOnlinePrediction, MdLocationOn } from 'react-icons/md';
import { GiPriceTag } from 'react-icons/gi';
import { Calendar, MapPin, Download } from 'lucide-react';
import './formation.css';
import Breadcrumb from './Breadcrumb';
import academieImage from '../assets/academi.jpeg';

// Images pour les formations (à remplacer par vos vraies images)
import pmpImage from '../assets/pmp.png';
import capmImage from '../assets/capm.png';
import pmicpImage from '../assets/pmi-cp.png';
import primaveraImage from '../assets/primavera.png';
import scrumImage from '../assets/psm1.png';
import powerbiImage from '../assets/power.png';
import projectImage from '../assets/mp.png';
import jiraImage from '../assets/jira.png';
import itilImage from '../assets/itil0.png';
import decisionImage from '../assets/capm.png';

const Formations = ({ openEligibilityModal }) => {
  const navigate = useNavigate(); // Ajoute ce hook
  const [formations, setFormations] = useState([]);
  const [filteredFormations, setFilteredFormations] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchQuery, setSearchQuery] = useState('');
  const [selectedCategory, setSelectedCategory] = useState('all');
  const [selectedFormat, setSelectedFormat] = useState('all');
  const [currentPage, setCurrentPage] = useState(1);
  const [formationsPerPage] = useState(12);
  const [showPriceModal, setShowPriceModal] = useState(false);

  // États pour les témoignages
  const [testimonials, setTestimonials] = useState([]);
  const [testimonialsLoading, setTestimonialsLoading] = useState(true);
  const [testimonialsError, setTestimonialsError] = useState(null);

  // Données du tableau des tarifs
  const priceData = [
    {
      designation: "Offre PMP® Standard",
      note: "Hors frais d'Examen PMP",
      condition: "",
      price: "1 130 000",
      currency: "FCFA"
    },
    {
      designation: "Offre PMP® Sponsorisée*",
      note: "Hors frais d'Examen PMP",
      condition: "*Sous conditions ; Limitée",
      price: "595 000",
      currency: "FCFA"
    },
    {
      designation: "Frais d'examen de Certification PMP",
      note: "",
      condition: "",
      price: "~ 230 000*",
      currency: "FCFA",
      priceNote: "*Selon taux dollar"
    }
  ];

  // Données du catalogue 2026 selon le format de l'image (avec toutes les formations)
  const catalogueData = [
    // T1 - Premier trimestre
    {
      code: "T1 IVTPMP",
      titre: "Préparation à la certification Project Management Professional (PMP)®",
      sousTitre: "Formation + coaching + Certification",
      lieu: "Cotonou",
      periodeFormation: "17, 18, 24, 25, 31 janvier 2026",
      periodeCoaching: "01 février au 17 avril 2026",
      duree: "60 heures",
      tarif: "1 360 000"
    },
    {
      code: "T1 IVTPMP",
      titre: "Préparation à la certification Project Management Professional (PMP)®",
      sousTitre: "Formation + coaching + Certification",
      lieu: "Lomé",
      periodeFormation: "14, 15, 21, 22, 28 février 2026",
      periodeCoaching: "01 mars au 14 mai 2026",
      duree: "60 heures",
      tarif: "1 360 000"
    },
    {
      code: "T1 IVTPMP",
      titre: "Préparation à la certification Project Management Professional (PMP)®",
      sousTitre: "Formation + coaching + Certification",
      lieu: "Cotonou",
      periodeFormation: "02 au 06 mars 2026",
      periodeCoaching: "07 mars au 07 juin 2026",
      duree: "60 heures",
      tarif: "1 360 000"
    },
    {
      code: "T1 IVTPSM",
      titre: "Préparation à la certification Professional Scrum Master™ I (PSM I)",
      sousTitre: "Formation + coaching + Certification",
      lieu: "Cotonou",
      periodeFormation: "10 au 12 mars 2026",
      periodeCoaching: "13 mars au 30 avril 2026",
      duree: "35 heures",
      tarif: "750 000"
    },
    {
      code: "T1 IVTGPO",
      titre: "Gestion de projet pour équipes opérationnelles : Prédictif + agile + outils",
      sousTitre: "Formation + pratique",
      lieu: "Cotonou",
      periodeFormation: "23 au 27 mars 2026",
      periodeCoaching: null,
      duree: "35 heures",
      tarif: "750 000"
    },

    // T2 - Deuxième trimestre
    {
      code: "T2 IVTMSP",
      titre: "Microsoft Project : Planification et suivi de projets",
      sousTitre: "Formation + pratique",
      lieu: "Cotonou",
      periodeFormation: "20 au 24 avril 2026",
      periodeCoaching: null,
      duree: "35 heures",
      tarif: "750 000"
    },
    {
      code: "T2 IVTPP6",
      titre: "Primavera P6 : Planification et suivi de projets",
      sousTitre: "Formation + pratique",
      lieu: "A distance",
      periodeFormation: "18 au 22 mai 2026",
      periodeCoaching: null,
      duree: "35 heures",
      tarif: "750 000"
    },
    {
      code: "T2 IVTPBI",
      titre: "Microsoft Power BI : Modélisation et Visualisation de données projets",
      sousTitre: "Formation + pratique",
      lieu: "A distance",
      periodeFormation: "15 au 19 juin 2026",
      periodeCoaching: null,
      duree: "35 heures",
      tarif: "750 000"
    },
    {
      code: "T2 IVTGPDP",
      titre: "Gestion de projets pour décideurs",
      sousTitre: "Formation + pratique",
      lieu: "Kigali",
      periodeFormation: "22 au 28 juin 2026",
      periodeCoaching: null,
      duree: "7 jours",
      tarif: "1 500 000"
    },

    // T3 - Troisième trimestre
    {
      code: "T3 IVTGPO",
      titre: "Gestion de projet pour équipes opérationnelles : Prédictif + agile + outils",
      sousTitre: "Formation + pratique",
      lieu: "Cotonou",
      periodeFormation: "06 au 10 juillet 2026",
      periodeCoaching: null,
      duree: "35 heures",
      tarif: "750 000"
    },
    {
      code: "T3 IVTPMP",
      titre: "Préparation à la certification Project Management Professional (PMP)*",
      sousTitre: "Préparation + coaching + examen blanc + Frais d'examen",
      lieu: "Cotonou",
      periodeFormation: "02,08,09,15,16 Aout 2026",
      periodeCoaching: "17 Aout au 17 Nov. 2026",
      duree: "60 heures",
      tarif: "1 360 000"
    },
    {
      code: "T3 IVTPMP",
      titre: "Préparation à la certification Project Management Professional (PMP)*",
      sousTitre: "Préparation + coaching + examen blanc + Frais d'examen",
      lieu: "Lome",
      periodeFormation: "16,22,23,29,30 Aout 2026",
      periodeCoaching: "01 Sept au 30 Nov. 2026",
      duree: "60 heures",
      tarif: "1 360 000"
    },
    {
      code: "T3 IVTPMP",
      titre: "Préparation à la certification Project Management Professional (PMP)*",
      sousTitre: "Formation + coaching + Certification",
      lieu: "Cotonou",
      periodeFormation: "07 au 11 Sept 2026",
      periodeCoaching: "12 Sept au 12 Déc. 2026",
      duree: "60 heures",
      tarif: "1 360 000"
    },
    {
      code: "T3 IVTITIL",
      titre: "Préparation à la certification ITIL*4 Fondation",
      sousTitre: "Formation + Frais d'examen",
      lieu: "Cotonou",
      periodeFormation: "21 au 23 Sept 2026",
      periodeCoaching: null,
      duree: "21 heures",
      tarif: "750 000"
    },

    // T4 - Quatrième trimestre
    {
      code: "T4 IVTPSM",
      titre: "Préparation à la certification Professional Scrum Master™ I (PSM I)",
      sousTitre: "Préparation + coaching + examen blanc + Frais d'examen",
      lieu: "Lome",
      periodeFormation: "12 au 14 Octobre 2026",
      periodeCoaching: "15 oct. au 30 Nov. 2026",
      duree: "35 heures",
      tarif: "750 000"
    },
    {
      code: "T4 IVTMSP",
      titre: "Microsoft Project : Planification et suivi de projets",
      sousTitre: "Formation + pratique",
      lieu: "Lome",
      periodeFormation: "16 au 20 Novembre 2026",
      periodeCoaching: null,
      duree: "35 heures",
      tarif: "750 000"
    },
    {
      code: "T4 IVTPP6",
      titre: "Primavera P6 : Planification et suivi de projets",
      sousTitre: "Formation + pratique",
      lieu: "A distance",
      periodeFormation: "07 au 11 Décembre 2026",
      periodeCoaching: null,
      duree: "35 heures",
      tarif: "750 000"
    }
  ];

  // Catégories de formations
  const categories = [
    { id: 'all', name: 'Toutes les formations', count: 8 },
    { id: 'pmi', name: 'Certifications PMI', count: 2 },
    { id: 'agile', name: 'Méthodes Agiles', count: 1 },
    { id: 'tools', name: 'Outils de gestion', count: 3 },
    { id: 'management', name: 'Management', count: 2 }
  ];

  // Formats de formation
  const formats = [
    { id: 'all', name: 'Tous les formats' },
    { id: 'presentiel', name: 'Présentiel' },
    { id: 'distanciel', name: 'Distanciel' },
    { id: 'mixte', name: 'Mixte' }
  ];

  useEffect(() => {
    // Simuler le chargement des données depuis l'API
    setTimeout(() => {
      const formationsData = [
        {
          id: 1,
          title: "Project Management Professional (PMP)<sup>®</sup>",
          shortTitle: "PMP<sup>®</sup>",
          category: "pmi",
          image: pmpImage,
          description: "Préparez-vous à l'examen PMP<sup>®</sup> et devenez un chef de projet certifié, reconnu mondialement. Formation + coaching + Certification inclus.",
          lien: "/preparation-au-pmp",
          lieu: "Présentiel: Cotonou, Lomé",
          lieu2: "Distanciel: Teams",
          dates: [
            "20 juin au 4 juillet 2026",
            "4 au 18 octobre 2026"
          ]
        },
        {
          id: 2,
          title: "PMI Construction Professional (PMI-CP)<sup>™</sup>",
          shortTitle: "PMI-CP<sup>™</sup>",
          category: "pmi",
          image: pmicpImage,
          description: "Débutez dans la gestion de projet avec la certification PMI-CP<sup>™</sup>.",
          lien: "/preparation-au-pmi-cp",
          lieu: "Présentiel: Cotonou, Lomé",
          lieu2: "Distanciel: Teams",
          dates: [
            // "16 mai 2026 et 19 juillet 2026",
            "19 septembre au 22 novembre 2026"
          ]
        },        
        {
          id: 3,
          title: "Certified Associate in Project Management (CAPM)<sup>®</sup>",
          shortTitle: "CAPM<sup>®</sup>",
          category: "pmi",
          image: capmImage,
          description: "Débutez dans la gestion de projet avec la certification CAPM<sup>®</sup>.",
          lien: "/preparation-au-capm",
          lieu: "Présentiel: Cotonou, Lomé",
          lieu2: "Distanciel: Teams",
          dates: [
            // "16 mai 2026 et 19 juillet 2026",
            "15 août au 22 août 2026"
          ]
        },
        // {
        //   id: 3,
        //   title: "Professional Scrum Master™ I (PSM I)",
        //   shortTitle: "PSM I",
        //   category: "agile",
        //   image: scrumImage,
        //   description: "Maîtrisez la méthodologie Scrum et préparez-vous à l'examen PSM I. Formation + coaching + Certification inclus.",
        // },
        // {
        //   id: 5,
        //   title: "Microsoft Project : Planification et suivi de projets",
        //   shortTitle: "Microsoft Project",
        //   category: "tools",
        //   image: projectImage,
        //   description: "Formation pratique pour maîtriser Microsoft Project dans la planification et le suivi de projets.",
        // },
        // {
        //   id: 6,
        //   title: "Primavera P6 : Planification et suivi de projets",
        //   shortTitle: "Primavera P6",
        //   category: "tools",
        //   image: primaveraImage,
        //   description: "Formation pratique pour maîtriser Primavera P6, l'outil référence des grands projets.",
        // },
        // {
        //   id: 7,
        //   title: "Microsoft Power BI : Modélisation et Visualisation de données projets",
        //   shortTitle: "Power BI",
        //   category: "tools",
        //   image: powerbiImage,
        //   description: "Formation pratique pour la modélisation et visualisation de données projets avec Power BI.",
        // },
        // {
        //   id: 9,
        //   title: "Préparation à la certification ITIL®4 Fondation",
        //   shortTitle: "ITIL®4",
        //   category: "management",
        //   image: itilImage,
        //   description: "Formation + Frais d'examen inclus pour la certification ITIL®4 Fondation.",
        // }
      ];

      setFormations(formationsData);
      setFilteredFormations(formationsData);
      setLoading(false);
    }, 1000);
  }, []);

  // Récupérer les témoignages depuis l'API
  useEffect(() => {
    fetchTestimonialsData();
  }, []);

  const fetchTestimonialsData = async () => {
    try {
      setTestimonialsLoading(true);
      // const response = await fetch('http://localhost/ivtcms/api/rubriques/by-url/Ils-nous-font-confiance');

      const response = await fetch(`${process.env.REACT_APP_HOTE}api/rubriques/by-url/Ils-nous-font-confiance`,)

      if (!response.ok) {
        throw new Error(`HTTP error! status: ${response.status}`);
      }

      const data = await response.json();

      if (data.success && data.data) {
        const rubriqueData = data.data;

        // Récupérer les articles (témoignages) depuis l'API
        if (rubriqueData.articles && rubriqueData.articles.length > 0) {
          const formattedTestimonials = rubriqueData.articles.map((article) => ({
            id: article.id_article,
            name: article.titre,
            certification: article.soustitre || "",
            text: cleanText(article.texte),
            avatar: getInitials(article.titre)
          }));
          setTestimonials(formattedTestimonials);
        } else {
          setTestimonials([]);
        }
      } else {
        throw new Error('Données de rubrique non disponibles');
      }

    } catch (err) {
      console.error('Erreur lors de la récupération des témoignages:', err);
      setTestimonialsError(err.message);
      setTestimonials([]);
    } finally {
      setTestimonialsLoading(false);
    }
  };

  const formatLocation = (text) => {
  if (!text) return "";
  // Inclure le deux-points dans la recherche
  const parts = text.split(/(Présentiel\s?:|Distanciel\s?:)/gi);
  return parts.map((part, index) => {
    if (part.toLowerCase().match(/pr[ée]sentiel\s?:|distanciel\s?:/)) {
      return <strong key={index} style={{ color: '#0a3764' }}>{part}</strong>;
    }
    return part;
  });
};

  // Nettoyer le texte des témoignages
  const cleanText = (text) => {
    if (!text) return "";
    return text
      .replace(/^"|"$/g, '')
      .replace(/\r\n/g, ' ')
      .replace(/\s+/g, ' ')
      .trim();
  };

  // Obtenir les initiales du nom
  const getInitials = (name) => {
    if (!name) return "??";
    return name
      .split(' ')
      .map(word => word[0])
      .join('')
      .toUpperCase()
      .substring(0, 2);
  };

  // Filtrer les formations
  useEffect(() => {
    let filtered = formations;

    // Filtre par recherche
    if (searchQuery) {
      filtered = filtered.filter(formation =>
        formation.title.toLowerCase().includes(searchQuery.toLowerCase()) ||
        formation.description.toLowerCase().includes(searchQuery.toLowerCase()) ||
        formation.shortTitle.toLowerCase().includes(searchQuery.toLowerCase())
      );
    }

    // Filtre par catégorie
    if (selectedCategory !== 'all') {
      filtered = filtered.filter(formation => formation.category === selectedCategory);
    }

    // Filtre par format
    if (selectedFormat !== 'all') {
      filtered = filtered.filter(formation => formation.format === selectedFormat);
    }

    setFilteredFormations(filtered);
    setCurrentPage(1);
  }, [searchQuery, selectedCategory, selectedFormat, formations]);

  // Pagination
  const indexOfLastFormation = currentPage * formationsPerPage;
  const indexOfFirstFormation = indexOfLastFormation - formationsPerPage;
  const currentFormations = filteredFormations.slice(indexOfFirstFormation, indexOfLastFormation);
  const totalPages = Math.ceil(filteredFormations.length / formationsPerPage);

  const paginate = (pageNumber) => setCurrentPage(pageNumber);

  const getFormatLabel = (format) => {
    switch (format) {
      case 'presentiel': return 'Présentiel';
      case 'distanciel': return 'Distanciel';
      case 'mixte': return 'Mixte';
      default: return format;
    }
  };

  const getCategoryCount = (categoryId) => {
    if (categoryId === 'all') return formations.length;
    return formations.filter(f => f.category === categoryId).length;
  };

  const handleShowPrice = () => {
    setShowPriceModal(true);
  };

  // Dans ton composant Formations
  const [currentIndex, setCurrentIndex] = useState(0);
  const [itemsToShow, setItemsToShow] = useState(3);
  const autoPlayInterval = useRef(null);

  // Déterminer le nombre d'éléments à afficher selon la taille d'écran
  useEffect(() => {
    const handleResize = () => {
      if (window.innerWidth < 768) {
        setItemsToShow(1);
      } else if (window.innerWidth < 1024) {
        setItemsToShow(2);
      } else {
        setItemsToShow(3);
      }
    };

    handleResize();
    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  // Fonction pour passer au témoignage suivant (défilement infini)
  const nextTestimonial = () => {
    setCurrentIndex((prevIndex) => {
      if (prevIndex + itemsToShow < testimonials.length) {
        return prevIndex + 1;
      } else {
        return 0; // Retour au début (défilement infini)
      }
    });
  };

  // Fonction pour passer au témoignage précédent
  const prevTestimonial = () => {
    setCurrentIndex((prevIndex) => {
      if (prevIndex > 0) {
        return prevIndex - 1;
      } else {
        return Math.max(0, testimonials.length - itemsToShow);
      }
    });
  };

  // Défilement automatique
  useEffect(() => {
    // Démarrer l'autoplay
    autoPlayInterval.current = setInterval(() => {
      nextTestimonial();
    }, 10000); // Change tous les 10 secondes

    // Nettoyer l'intervalle au démontage
    return () => {
      if (autoPlayInterval.current) {
        clearInterval(autoPlayInterval.current);
      }
    };
  }, [testimonials.length, itemsToShow]); // Re-démarrer si les données changent

  // Pause au survol
  const stopAutoPlay = () => {
    if (autoPlayInterval.current) {
      clearInterval(autoPlayInterval.current);
      autoPlayInterval.current = null;
    }
  };

  const startAutoPlay = () => {
    if (!autoPlayInterval.current) {
      autoPlayInterval.current = setInterval(() => {
        nextTestimonial();
      }, 10000);
    }
  };

  // Témoignages visibles
  const visibleTestimonials = testimonials.slice(currentIndex, currentIndex + itemsToShow);

  return (
    <>
      <Breadcrumb />
      <section className="formations-page">
        <div className="entreprise-page-hero" >
          <img
            src={academieImage}
            alt="Background"
            className="entreprise-page-hero-bg"
            style={{ width: '100%', height: '100%', objectFit: 'cover' }}
          />
          <div className="entreprise-page-hero-overlay"></div>
          <div className="entreprise-page-hero-content">
            <h1 className="entreprise-page-hero-title">Académie</h1>
            <p className="entreprise-page-hero-subtitle">
              Obtenez une certification reconnue et accélérez votre carrière
            </p>
            <p className="entreprise-page-hero-text">
              Explorez nos formations certifiantes et réservez votre place pour les prochaines sessions
            </p>
          </div>
        </div>
        <div className="contenir">
          <div className="formations-header">
            <h1 className="section-title">Nos formations</h1>
            <p className="section-subtitle">

              Aujourd'hui, la performance des organisations dépend de leur capacité à livrer des projets à forte valeur ajoutée.
              Pourtant, malgré des milliers de milliards de dollars investis chaque année dans le monde, la majorité d'entre eux dépassent les délais,
              explosent les budgets ou ne délivrent pas la valeur attendue faute de pilotage efficace.

              Selon les projections du PMI et de PwC, 25 millions de nouveaux professionnels en management de projet seront nécessaires dans le monde d'ici 2030.
              Les organisations recherchent des profils certifiés, crédibles et immédiatement opérationnels.
              <br />
              Dans un marché de plus en plus exigeant, les certifications ne vous rend pas simplement plus compétent,
              il vous rend visible, différenciant et incontournable. Vous prenez une longueur d'avance sur un marché en forte tension.
              Préparez efficacement vos certifications avec un accompagnement structuré et orienté réussite.

            </p>
          </div>

          <div className="formations-layout">
            {/* Liste des formations */}
            <main className="formations-list">
              {loading ? (
                <div className="loading-state">
                  <div className="spinner"></div>
                  <p>Chargement des formations...</p>
                </div>
              ) : filteredFormations.length === 0 ? (
                <div className="empty-state">
                  <FaSearch size={48} />
                  <h3>Aucune formation trouvée</h3>
                  <p>Essayez de modifier vos filtres de recherche</p>
                </div>
              ) : (
                <>
                  <div className="formations-grid">
                    {currentFormations.map(formation => (
                      <div key={formation.id} className="formation-card">
                        <div className="card-image">
                          <img src={formation.image} alt={formation.title} />
                        </div>

                        <div className="card-content">
                          <h3 className="formation-title" dangerouslySetInnerHTML={{ __html: formation.title }} />
                          <p className="formation-description" dangerouslySetInnerHTML={{ __html: formation.description }} />

                          <div className="formation-infos">
                            <div className="info-item">
                              <i className="fas fa-map-marker-alt" style={{ size: "55px" }}></i>
                              <div className="lieux-stack">
                                <span className="lieu-1">{formatLocation(formation.lieu || "")}</span> <br />
                                <span className="lieu-2">{formatLocation(formation.lieu2 || "")}</span>
                              </div>
                            </div>

                            {/* Nouvelle section dates avec "Prochaines sessions" */}
                            <div className="info-item date-section">
                              <div className="dates-header">
                                <i className="fas fa-calendar-alt"></i>
                                <span className="sessions-label">Prochaines sessions</span>
                              </div>
                              <div className="dates-stack">
                                {formation.dates ? (
                                  formation.dates.map((date, idx) => (
                                    <span key={idx} className="date-line">{date}</span>
                                  ))
                                ) : (
                                  <span className="date-line">{formation.date || "Disponible"}</span>
                                )}
                              </div>
                            </div>
                          </div>

                          <div className="card-footer">
                            <button
                              className="btn-details"
                              onClick={() => navigate(formation.lien)}
                            >
                              Voir détails
                            </button>
                          </div>
                        </div>
                      </div>
                    ))}
                  </div>

                  {/* Pagination */}
                  {totalPages > 1 && (
                    <div className="pagination">
                      <button
                        onClick={() => paginate(currentPage - 1)}
                        disabled={currentPage === 1}
                        className="pagination-btn"
                      >
                        Précédent
                      </button>

                      {[...Array(totalPages)].map((_, i) => (
                        <button
                          key={i + 1}
                          onClick={() => paginate(i + 1)}
                          className={`pagination-btn ${currentPage === i + 1 ? 'active' : ''}`}
                        >
                          {i + 1}
                        </button>
                      ))}

                      <button
                        onClick={() => paginate(currentPage + 1)}
                        disabled={currentPage === totalPages}
                        className="pagination-btn"
                      >
                        Suivant
                      </button>
                    </div>
                  )}
                </>
              )}
            </main>
          </div>
        </div>
      </section>

      {/* Section Témoignages */}
      <section className="testimonials-section">
        <div className="contenir">
          <div className="testimonials-header">
            <h2 className="section-title">Ils témoignent</h2>
            <p className="section-subtitle">
              Découvrez ce que nos apprenants disent de nos formations
            </p>
          </div>

          {testimonialsLoading ? (
            <div className="testimonials-loading">
              <div className="spinner"></div>
              <p>Chargement des témoignages...</p>
            </div>
          ) : testimonialsError ? (
            <div className="testimonials-error">
              <p style={{ color: '#ff6b6b' }}>Erreur de chargement : {testimonialsError}</p>
            </div>
          ) : testimonials.length === 0 ? (
            <p style={{ textAlign: 'center', color: '#666', margin: '4rem 0' }}>
              Aucun témoignage à afficher pour le moment.
            </p>
          ) : (
            <div
              className="testimonials-wrapper"
              onMouseEnter={stopAutoPlay}
              onMouseLeave={startAutoPlay}
            >
              {/* Flèche gauche */}
              <button
                className="testimonial-arrow left"
                onClick={prevTestimonial}
              // style={{ visibility: currentIndex === 0 ? 'hidden' : 'visible' }}
              >
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 320 512"
                  className="carousel-icon"
                  color="#0a3764"
                  height="20"
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path>
                </svg>
              </button>

              {/* Grille des témoignages - Carrousel continu */}
              <div className="testimonials-grid">
                {/* <div className="testimonials-carousel" ref={carouselRef}> */}
                {visibleTestimonials.map((testimonial, idx) => (
                  <div className="testimonial-card" key={`${testimonial.id}-${idx}`}>
                    <div className="testimonial-quote">
                      <FaQuoteLeft className="quote-icon" />
                    </div>
                    <p className="testimonial-content">"{testimonial.text}"</p>
                    <div className="testimonial-author">
                      <div className="author-avatar">
                        <div className="avatar-circle">{testimonial.avatar}</div>
                      </div>
                      <div className="author-info">
                        <h4 className="author-name">{testimonial.name}</h4>
                        <p className="author-certification" dangerouslySetInnerHTML={{ __html: testimonial.certification }} />
                      </div>
                    </div>
                  </div>
                ))}
                {/* </div> */}
              </div>

              {/* Flèche droite */}
              <button
                className="testimonial-arrow right"
                onClick={nextTestimonial}
              // style={{ visibility: currentIndex + itemsToShow >= testimonials.length ? 'hidden' : 'visible' }}
              >
                <svg
                  stroke="currentColor"
                  fill="currentColor"
                  strokeWidth="0"
                  viewBox="0 0 320 512"
                  className="carousel-icon right"
                  color="#0a3764"
                  height="20"
                  width="20"
                  xmlns="http://www.w3.org/2000/svg"
                  style={{ transform: 'rotate(180deg)' }}
                >
                  <path d="M34.52 239.03L228.87 44.69c9.37-9.37 24.57-9.37 33.94 0l22.67 22.67c9.36 9.36 9.37 24.52.04 33.9L131.49 256l154.02 154.75c9.34 9.38 9.32 24.54-.04 33.9l-22.67 22.67c-9.37 9.37-24.57 9.37-33.94 0L34.52 272.97c-9.37-9.37-9.37-24.57 0-33.94z"></path>
                </svg>
              </button>
            </div>
          )}
        </div>
      </section>
    </>
  );
};

export default Formations;